import { LanguageItem } from '../../../../../app/layout/StoreSelectionState';
import { LanguageSelectorTranslation } from '../../../../../app/localization/SiteTranslation';
import css from './LanguageSelector.css';

interface LanguageSelectorProps {
  items: LanguageItem[];
  selectedItem: LanguageItem;
  translation: LanguageSelectorTranslation;
  onSelect: (language: LanguageItem) => void;
}

export default function LanguageSelector({ items, selectedItem, translation, onSelect }: LanguageSelectorProps) {
  return (
    <section>
      <h3 className={css.heading}>{translation.title}</h3>
      <ul className={css.items}>
        {items.map((language) => (
          <li key={language.code}>
            <button
              type="button"
              className={css.button}
              aria-current={language.code === selectedItem.code}
              onClick={() => onSelect(language)}
            >
              {language.displayName}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
